import { render, staticRenderFns } from "./TitleMobile.vue?vue&type=template&id=6cb00acb&scoped=true"
import script from "./TitleMobile.vue?vue&type=script&lang=js"
export * from "./TitleMobile.vue?vue&type=script&lang=js"
import style0 from "./TitleMobile.vue?vue&type=style&index=0&id=6cb00acb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb00acb",
  null
  
)

export default component.exports